export const joinAutoNumber = (number: string, region?: string | null) =>
  `${number}${region ?? ''}`.replaceAll(/\s+/g, '')

export const formatAutoNumber = (number: string, region?: string | null) =>
  region ? `${number} ${region}` : number

export const moveItem = <T>(items: T[], from: number, to: number) => {
  if (
    from === to ||
    from < 0 ||
    to < 0 ||
    from >= items.length ||
    to >= items.length
  ) {
    return items
  }

  const next = [...items]
  const [moved] = next.splice(from, 1)

  next.splice(to, 0, moved)

  return next
}
